import React from 'react';
import { Route, Routes, } from "react-router-dom";
import AdminHeader from '../Components/AdminHeader';
import AdminSidebar from '../Components/AdminSidebar';
import Dashboard from '../Layouts/Dashboard/Dashboard';
import CreateClient from '../Layouts/Clients/CreateClient';
import ClientDashboard from '../Layouts/Clients/ClientDashboard';
import AllClients from '../Layouts/Clients/AllClients';
import CreateChargebasis from '../Layouts/Pricing/Chargebasis/CreateChargebasis';
import AllChargebasis from '../Layouts/Pricing/Chargebasis/AllChargebasis';
import PricingDashboard from '../Layouts/Pricing/PricingDashboard';
import PackageDashboard from '../Layouts/Pricing/Package/PackageDashboard';
import CreatePackage from '../Layouts/Pricing/Package/CreatePackage';
import EditPackage from '../Layouts/Pricing/Package/EditPackage';
import AllPackages from '../Layouts/Pricing/Package/AllPackages';
import AllServices from '../Layouts/Pricing/Services/AllServices';
import CreateServices from '../Layouts/Pricing/Services/CreateServices';
import EditServices from '../Layouts/Pricing/Services/EditService';

import EditChargebasis from '../Layouts/Pricing/Chargebasis/EditChargebasis';
import ViewPackage from '../Layouts/Pricing/Package/ViewPackage';

import ContractTemplate from '../Layouts/Templates/Contract/CreateContractTemplate';
import ContractDashboard from '../Layouts/Contract/ContractDashboard';
import CreateContract from '../Layouts/Contract/ContractCreation/CreateContract';
import AllContracts from '../Layouts/Contract/AllContracts';
import CreateContractTemplate from '../Layouts/Templates/Contract/CreateContractTemplate';
import AllContractTemplet from '../Layouts/Templates/Contract/AllContractTemplet';
import EditContractTemplet from '../Layouts/Templates/Contract/EditContractTemplet';


import QuotesList from '../Layouts/Quotes/AllQuotes';
import QuotesDashboard from '../Layouts/Quotes/QuotesDashboard';
import CreateQuoteTemplate from '../Layouts/Templates/Quote/CreateQuoteTemplate';
import AllQuotesTemplet from '../Layouts/Templates/Quote/AllQuotTemplet';
import EditQuoteTemplet from '../Layouts/Templates/Quote/EditQuoteTemplate';

import AllEmailTemplate from '../Layouts/Templates/Email/AllEmailTemplate';
import CreateEmailTemplate from '../Layouts/Templates/Email/CreateEmailTemplate';
import EditEmailTemplate from '../Layouts/Templates/Email/EditEmailTemplet';


import CreateQuote from '../Layouts/Quotes/QuoteCreation/CreateQuote';
import CommonTemplet from '../Layouts/Templates/CommonTemplet/AllCommonTemplet';
import AddCommonTemplet from '../Layouts/Templates/CommonTemplet/AddCommonTemplet';
import EditCommonTemplet from '../Layouts/Templates/CommonTemplet/EditCommonTemplet';


import CP from '../Layouts/Templates/Quote/CreateQuoteTemplate1'
import Configsetting from '../Layouts/configsetting/Configsetting';



const AdminRoute = () => {
    return (
        <div className="admin-container">
            <AdminHeader />
            <div className="admin-content">
                <AdminSidebar />
                <main id="main" className="main">
                    <div className="admin-main">
                        <Routes>
                            <Route path="/dashboard" element={<Dashboard />} />
                            <Route path="/client/dashboard" element={<ClientDashboard />} />
                            <Route path="/client/create-clients" element={<CreateClient />} />
                            <Route path="/client/all-client" element={<AllClients />} />
                            <Route path="/quote/quotes-dashboard" element={<QuotesDashboard />} />
                            <Route path="/quote/all-quotes" element={<QuotesList />} />
                            <Route path="/template/all-email-template" element={<AllEmailTemplate />} />
                            <Route path="/template/create-email-template" element={<CreateEmailTemplate />} />
                            <Route path="/template/contract-template" element={<ContractTemplate />} />
                            <Route path="/template/create-quote-template" element={<CreateQuoteTemplate />} />
                            <Route path="/contract/template" element={<ContractTemplate />} />
                            <Route path="/pricing/all-charge-basis" element={<AllChargebasis />} />
                            <Route path="/pricing/create-charge-basis" element={<CreateChargebasis />} />
                            <Route path="/contracts/contracts-dashboard" element={<ContractDashboard />} />
                            <Route path="/contracts/create-contract" element={<CreateContract />} />
                            <Route path="/contracts/all-contracts" element={<AllContracts />} />
                            <Route path="/pricing" element={<PricingDashboard />} />
                            <Route path="/pricing/package" element={<PackageDashboard />} />
                            <Route path="/pricing/all-packages" element={<AllPackages />} />
                            <Route path="/pricing/create-package" element={<CreatePackage />} />
                            <Route path="/pricing/edit-package" element={<EditPackage />} />
                            <Route path="/pricing/view-package" element={<ViewPackage />} />
                            <Route path="/pricing/all-services" element={<AllServices />} />
                            <Route path="/pricing/create-services" element={<CreateServices />} />
                            <Route path="/pricing/edit-services" element={<EditServices />} />

                            <Route path="/pricing/edit-charge-basis" element={<EditChargebasis />} />
                            <Route path="/template/create-quote-template" element={<CreateQuoteTemplate />} />
                            <Route path="/template/all-quote-template" element={< AllQuotesTemplet />} />
                            <Route path="/template/edit-quote-template" element={< EditQuoteTemplet />} />
                            <Route path="/template/all-contract-template" element={< AllContractTemplet />} />
                            <Route path="/template/create-contract-template" element={< CreateContractTemplate />} />
                            <Route path="/template/edit-contract-template" element={< EditContractTemplet />} />
                            <Route path="/template/edit-email-template" element={< EditEmailTemplate />} />
                            <Route path="/quote/create-quote" element={< CreateQuote />} />
                            <Route path="/template/all-common-template" element={< CommonTemplet />} />
                            <Route path="/template/add-common-template" element={< AddCommonTemplet />} />
                            <Route path="/template/edit-common-template" element={< EditCommonTemplet />} />
                            <Route path="/cp" element={<CP />} />
                            <Route path="/configsetting" element={<Configsetting />} />



                        </Routes>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default AdminRoute;

